import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {DhlOrderForm} from '../models/order-form';

export const dhlValidateAddressShippingActionTypes = {
  VALIDATED_SHIPPING: type('[DHL Address Shipping Validate] Add '),
  VALIDATED_SUCCESS_SHIPPING: type('[DHL Address Shipping Validate] Add Success'),
  VALIDATED_FAIL_SHIPPING: type('[DHL Address Shipping Validate] Add Fail')
};

export class ValidatedAddressShippingDHLAction implements Action {
  readonly type = dhlValidateAddressShippingActionTypes.VALIDATED_SHIPPING;
  constructor(public payload?: DhlOrderForm) {
  }
}

export class ValidatedAddressShippingDHLSuccessAction implements Action {
  readonly type = dhlValidateAddressShippingActionTypes.VALIDATED_SUCCESS_SHIPPING;
  constructor(public payload?: Object) {}
}

export class ValidatedAddressShippingDHLFailAction implements Action {
  readonly type = dhlValidateAddressShippingActionTypes.VALIDATED_FAIL_SHIPPING;
  constructor(public payload?: string) {}
}

